export default {
  MerchantCode: "MerchantCode (Mã đơn vị)",
  CheckSumKey: "CheckSumKey (Khóa bảo mật)",
  TerminalID: "Terminal ID (Mã điểm thu)",
  WebsiteName: "Tên website",
  WebsiteNameDetail: "Tên trang web bán hàng",
  Webhook: "Webhook",
  Logo: "Logo",
  businessform: "Hình thức kinh doanh",
  PaymentInfo: "Thông tin tài khoản thanh toán",
  PaymentInfoDes: "Số tiền giao dịch thu được sẽ được chuyển vào tài khoản này",
  BusinessType: "Loại hình",
  Bank: "Ngân hàng",
  BankBranch: "Chi nhánh ngân hàng",
  terms: "Bằng việc chọn hoàn thành bạn xác nhận đã đọc và đồng ý với",
  termslink: "điều khoản sử dụng dịch vụ của JetPay",
  title: "Định danh tài khoản",
  Online: "Online",
  Offline: "Offline",
  Province: "Tỉnh/Thành phố",
  District: "Quận/Huyện",
  Wards: "Phường/Xã",
  Address: "Địa chỉ",
  ServiceTypeGateway: "Cổng thanh toán",
  ServiceTypeBiling: "Thu hộ, chi hộ",
  enterprise: "Doanh nghiệp",
  personal: "Hộ cá thể",
  service: "Dịch vụ",
  fullname: "Họ & tên",
  position: "Chức vụ",
  CitizenType: "Loại giấy tờ",
  CitizenID: "Số CCCD",
  RegularAddress: "Địa chỉ thường chú",
  Type: "Loại",
  DocsType: "Loại giấy tờ",
  FrontSide: "Mặt trước",
  BackSide: "Mặt sau",
  PassportPage2: "Trang thứ 2 hộ chiếu",
  CMT: "CMT",
  CCCD: "CCCD",
  Passport: "Hộ chiếu",
  CMTNo: "Số CMT",
  CCCDNo: "Số CCCD",
  PassportCode: "Số hộ chiếu",
  next: "Tiếp theo",
  back: "Quay lại",
  submit: "Hoàn thành",
  LegalRepresentativeInfo: "Thông tin người đại diện pháp luật",
  AuthorizedPersonInfo: "Thông tin người ủy quyền",
  BusinessInfo: "Thông tin đăng ký kinh doanh",
  BusinessInfoPaper: "Giấy đăng ký kinh doanh",
  BusinessTaxNo: "Mã số đăng ký kinh doanh",
  BusinessTaxCode: "Mã số thuế",
  PhoneNumber: "Số điện thoại",
  AuthorizeDoc: "Văn bản ủy quyền",
  Field: "Ngành nghề kinh doanh",
  SignerIsLegalRepresentative: "Người ký hợp đồng là người đại diện",
  Name: "Tên đơn vị",
  PaymentOwner: "Chủ tài khoản",
  PaymentNo: "Số tài khoản",
  upload: "hoặc kéo thả ảnh vào đây",
  upload2: "hoặc kéo thả tệp để tải ảnh",
  uploadbutton: "tải lên",
  uploadClickHere: "Bấm vào đây",
  selectImage: "Chọn ảnh",
  uploadDes: "Chấp nhận file: jpg, jpeg png có dung lượng tối đa 5MB.",
  breadcrumb: {
    step1: "Thông tin đăng ký kinh doanh",
    step2: "Người đại diện, ủy quyền",
    step3: "Thông tin tài khoản thanh toán",
  },
  warning: {
    pendingIdentify:
      "Tài khoản kinh doanh của bạn đang được định danh. JetPay sẽ kiểm tra hồ sơ để phản hồi trong 2 giờ làm việc và gửi kết quả qua email bạn đã cung cấp.",
    denyIdentify:
      "Hồ sơ định danh của bạn đã bị từ chỗi. Lý do: ####. Vui lòng cập nhật lại hồ sơ định danh.",
    BusinessForm: "Bạn phải chọn ít nhất một hình thức thanh toán",
    InvalidFileNumber: "Bạn chỉ được chọn tối đa 6 file",
    InvalidFileSize: "Dung lượng file được được vượt quá 5MB",
    InvalidFileType: "Định dạng file không được chấp nhận",
    InvalidFile: "File được chọn không hợp lệ",
  },
  toastSuccess:
    "Chúc mừng bạn đăng ký thành công tài khoản kinh doanh. JetPay sẽ kiểm tra hồ sơ để phản hồi trong 2 giờ làm việc và gửi kết quả qua email bạn đã cung cấp",
  IdentifySuccess:
    "Hồ sơ của bạn đã được phê duyệt. Bạn sẽ được chuyển đến trang đăng nhập để tiếp tục sử dụng chương trình",
  LicenseFiles: "licenseFiles",
  IdentifyId: "identifyId",
  ExtractInformation: "Đang trích xuất thông tin ...",
  ChangeImage: "Tải lên tệp thay thế",
};
